/**
 * 搜索结果页路径
 */
export const SEARCH_RESULT_PAGE_PATH = '/search'
